import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonServices } from '../Common/CommonServices';
import { LoginServiceService } from '../Services/login-service.service';
import { RoutingParamService } from '../Services/routing-param.service';
import { UserClient, User, MyAccountClient, UserComDTO, WebinarClient, RecentWinnerDTO } from '../Services/WOWApi.Service';
import { CommonService } from '../Services/common.service';

interface WinnerFeedItem {
  uid: number;
  displayName?: string;
  initial?: string;
  prizeName?: string;
  imageUrl?: string;
  wonOn?: Date;
}

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  emailOtpRequestId: number = 0;
  mobileOtpRequestId: number = 0;
  isEmailVerified = false;
  isMobileVerified = false;
  otpTypeEmailMobile = new UntypedFormControl();
  isForgotPasswordPcessStarted = false;
  userComDetails: UserComDTO;

  userName: string;
  password: string;
  loginForm: UntypedFormGroup;
  showSpinner: boolean = false;
  routingPath: string = "Webinar-rooms";
  hidePw = true;
  VerificationEmailOtp = new UntypedFormControl();
  VerificationOtpMobile = new UntypedFormControl();
  NewPassword = new UntypedFormControl();
  isMobileView = false;
  subscription: Subscription;

  otp_timer: number = 30;
  interval_var: any;

  recentWinners: RecentWinnerDTO[] = [];
  feedItems: WinnerFeedItem[] = [];
  private destroyed = false;
  private readonly fallbackImage = 'assets/Images/demo1.png';
  private feedTimeout: ReturnType<typeof setTimeout> | null = null;
  private feedIndex = 0;
  private feedUid = 0;
  private readonly feedIntervalMs = 2400;
  private readonly feedVisibleCount = 6;

  constructor(private http: HttpClient,
    private formBuilder: UntypedFormBuilder,
    private commonServices: CommonServices,
    private client: UserClient,
    private webinarClient: WebinarClient,
    private router: Router,
    private loginServiceService:LoginServiceService,
    private commonService: CommonService,
    private routingParam: RoutingParamService,
    private MyAccountClient: MyAccountClient) 
    { 
      this.otpTypeEmailMobile.patchValue(false);
      this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    }

  ngOnInit(): void {
    this.onWindowResize();
    this.routingParam.routingParams.subscribe(response => {
      console.log(response);
      if (!!response) {
        this.routingPath = response.path;
      }
    });
    if (localStorage["UserInfo"] != null && localStorage["UserInfo"] != undefined) {
      this.router.navigate([this.routingPath]);
    }
    else {
      this.GetForm();
      this.loadRecentWinners();
    }

  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.clearWinnerFeed();
    this.subscription?.unsubscribe();
  }

  trackFeedItem(_index: number, item: WinnerFeedItem): number {
    return item.uid;
  }

  onPrizeImageError(event: Event): void {
    const image = event.target as HTMLImageElement;
    if (image && image.src.indexOf(this.fallbackImage) === -1) {
      image.src = this.fallbackImage;
    }
  }

  private loadRecentWinners(): void {
    this.webinarClient.getRecentWinners().subscribe({
      next: (winners) => {
        if (this.destroyed) {
          return;
        }
        this.recentWinners = (winners || []).filter(item => !!item?.displayName && !!item?.prizeName);
        this.startWinnerFeed();
      },
      error: () => {
        this.recentWinners = [];
        this.feedItems = [];
      }
    });
  }

  private startWinnerFeed(): void {
    this.clearWinnerFeed();
    this.feedItems = [];
    this.feedIndex = 0;
    if (!this.recentWinners.length) {
      return;
    }

    const seed = this.prefersReducedMotion()
      ? Math.min(this.feedVisibleCount, this.recentWinners.length)
      : Math.min(3, this.recentWinners.length);
    for (let i = 0; i < seed; i++) {
      this.appendWinnerToFeed();
    }
    if (!this.prefersReducedMotion()) {
      this.scheduleWinnerFeed();
    }
  }

  private scheduleWinnerFeed(): void {
    this.clearWinnerFeed();
    if (this.destroyed || this.recentWinners.length < 2) {
      return;
    }
    this.feedTimeout = setTimeout(() => {
      this.appendWinnerToFeed();
      this.scheduleWinnerFeed();
    }, this.feedIntervalMs);
  }

  private appendWinnerToFeed(): void {
    const source = this.recentWinners[this.feedIndex % this.recentWinners.length];
    this.feedIndex += 1;
    const next: WinnerFeedItem = {
      uid: ++this.feedUid,
      displayName: source.displayName,
      initial: source.initial,
      prizeName: source.prizeName,
      imageUrl: source.imageUrl,
      wonOn: source.wonOn
    };
    const items = [...this.feedItems, next];
    this.feedItems = items.slice(-this.feedVisibleCount);
  }

  private clearWinnerFeed(): void {
    if (this.feedTimeout) {
      clearTimeout(this.feedTimeout);
      this.feedTimeout = null;
    }
  }

  private prefersReducedMotion(): boolean {
    return typeof window !== 'undefined'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  formatWonOn(wonOn?: Date): string {
    if (!wonOn) {
      return 'Recently';
    }
    const won = wonOn instanceof Date ? wonOn : new Date(wonOn);
    if (Number.isNaN(won.getTime())) {
      return 'Recently';
    }
    const diffMs = Date.now() - won.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays <= 0) {
      return 'Today';
    }
    if (diffDays === 1) {
      return 'Yesterday';
    }
    if (diffDays < 7) {
      return `${diffDays} days ago`;
    }
    return won.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  }

  GetUserInfo() {
    this.client.getUsers().subscribe(x => {
      console.log('x');
      console.log(x);
    });
  }
  GetForm() {
    this.loginForm = this.formBuilder.group({
      EmailId: ['', [Validators.required, Validators.email]],
      Password: ['', Validators.required]
    });

  }
  GetFormData() {
    this.userName = this.loginForm.controls["EmailId"].value;
    this.password = this.loginForm.controls["Password"].value;
  }

  onFormSubmit() {
    if (!this.isForgotPasswordPcessStarted) {
      this.Login();
    }
  }

  Login() {
    this.GetFormData();
    if (this.userName == undefined || this.userName.length == 0) {
      alert("User id is required");
      return false;
    }
    else if (this.password == undefined || this.password.length == 0) {
      alert("Password is required");
      return false;
    }
    this.showSpinner = true;
    this.client.validateUser(this.userName, this.password).subscribe(user => {
      if (user != null) {
        localStorage.setItem("UserInfo", JSON.stringify(user));
        console.log(user);
        if (user.isHost == true || user.isOwner == true) {
        this.commonService.setUserHostOrAdmin(true);  
        }
        if (user.isHost == true) {
          this.commonServices.showMessage("Welcome", `Hello ${user.firstName + ' ' + user.lastName}, You are User as well as Host on the portal.`, 5); 
        }
        this.commonService.setUserLoggedIn(true);
        // window.location.reload();
        if(this.loginServiceService.redirectUrl)
        {
          this.router.navigate([this.loginServiceService.redirectUrl]);
        }
        else
        {
        this.router.navigate([this.routingPath]);
        }
      }
      else { this.commonServices.showMessage("Error", "Invalid Username Or Password,", 10); }
      this.showSpinner = false;
    }, (error) => {
      this.showSpinner = false;
      this.commonServices.showMessage("Error", "Invalid Username Or Password - Contact Support Team.", 5);

    })


  }

  onReset() {
    this.loginForm.reset();
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.commonService.isMobileView.subscribe(res => {
      const elements = document.getElementById('loginPage');
      if (!elements) {
        return;
      }
      if (res === false) {
        elements.classList.add('center');
      } else {
        elements.classList.remove('center');
      }
    });
  }

  GenerateEmailOtp(emailId: string, reason: string) {
    this.MyAccountClient.generateEmailOtp(emailId, reason).subscribe(res => {
      if (res > 0) {
        this.commonServices.showMessage('success', 'Email OTP has been generated successfully. It is valid for 10 minutes. Please check your email for the OTP.', 5);
        this.VerificationEmailOtp.setValidators([Validators.required, Validators.minLength(6)]);
        this.emailOtpRequestId = res;
        this.startOtptimer();
      } else {
        this.commonServices.showMessage('error', `Please provide correct EmailId to generate OTP, User not found with EmailId '${emailId}'.`, 5);
        this.emailOtpRequestId = 0;
      }
    }, error => {
      this.commonServices.showMessage('error', error, 5);
      this.emailOtpRequestId = 0;
    });
  }

  startOtptimer() {
    this.otp_timer = 30;
    this.interval_var = setInterval(() => {
      this.otp_timer--;
      if (this.otp_timer == 0) {
        clearInterval(this.interval_var);
      }
    }, 1000);
  }

  stopOtpTimer() {
    clearInterval(this.interval_var);
  }

  GenerateMobileOtp(emailId: string, reason: string) {
    this.MyAccountClient.sendMobileOtp(emailId, reason).subscribe(res => {
      if (res > 0) {
        this.commonServices.showMessage('success', 'Mobile OTP has been generated successfully. It is valid for 10 minutes. Please check your email for the OTP.', 5);
        this.VerificationEmailOtp.setValidators([Validators.required, Validators.minLength(6)]);
        this.mobileOtpRequestId = res;
        this.startOtptimer();
      } else {
        this.commonServices.showMessage('error', `Please provide correct EmailId to generate OTP, User not found with EmailId '${emailId}'.`, 5);
        this.mobileOtpRequestId = 0;
      }
    }, error => {
      this.commonServices.showMessage('error', 'Only US numbers are allwed to send the mobile OTP.', 5);
      this.mobileOtpRequestId = 0;
    });
  }

  VerifyOtp(requestId: number, otp: string, emailId: string) {
    this.MyAccountClient.verifyOtp(requestId, otp, emailId).subscribe(res => {
      if (res === true) {
        this.commonServices.showMessage('success', 'Email verified successfully, please update your password without refreshing your screen.', 7);
        this.NewPassword.setValue(null);
        this.NewPassword.setValidators([Validators.required, Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,30}$')]);
        this.isEmailVerified = true;
        this.stopOtpTimer();
      } else {
        this.commonServices.showMessage('error', 'Invalid OTP, please provide valid OTP.', 5);
        this.isEmailVerified = false;
      }
    }, error => {
      this.commonServices.showMessage('error', error, 5);
      this.isEmailVerified = false;
    });
  }

  ResetPassword(emailId: string, password: string) {
    if (this.emailOtpRequestId <= 0 && this.mobileOtpRequestId <= 0) {
      this.commonServices.showMessage('eror', 'Your verification id is not valid, please revailate.', 5);
      return;
    }
    const otpRequestId = this.emailOtpRequestId > 0 ? this.emailOtpRequestId : this.mobileOtpRequestId;
    this.client.passowrdReset(emailId, password, otpRequestId).subscribe(res => {
      if (res === true) {
        this.commonServices.showMessage('success', 'Password reset is successfully, please login with new password.', 5);
        this.VerificationEmailOtp.reset();
        this.NewPassword.reset();
        setTimeout(() => {
          location.reload();
        }, 2000);
      } else {
        this.commonServices.showMessage('error', 'Could not resset the password, please try after sometime.', 5);
      }
    }, error => {
      this.commonServices.showMessage('error', error, 5);
    });
  }

  onBecomeHost() {
    this.loginServiceService.redirectUrl = '/SignUpHost';
    if (localStorage.getItem('UserInfo')) {
      this.router.navigate(['/SignUpHost']);
      return;
    }
    this.router.navigate(['/Register'], { queryParams: { asHost: '1' } });
  }

  onForgotPassword() {
    if (this.loginForm.controls.EmailId.value.trim() === '' || !this.loginForm.controls.EmailId.valid) {
      this.isForgotPasswordPcessStarted = false;
      if (this.loginForm.controls.EmailId.value.trim() === '') {
        this.commonServices.showMessage('error', 'EmailId is required', 5);
        return;
      }
      if (!this.loginForm.controls.EmailId.valid) {
        this.commonServices.showMessage('error', 'Please provide valid EmailId', 5);
        return;
      }
    } else {
      this.getUserComDetails(this.loginForm.controls.EmailId.value.trim());
    }
  }

  getUserComDetails(emailId: string) {
    this.MyAccountClient.getUserComForForgotPassword(emailId).subscribe(res => {
      if (res.emailId === '0') {
        this.commonServices.showMessage('error', `EmailId '${emailId}' is not registered with us.`, 5);
      } else {
        this.userComDetails = res;
        this.isForgotPasswordPcessStarted = true;
        if (this.userComDetails.mobileNumber === '0') {
          this.otpTypeEmailMobile.setValue('email');
        }
        if (res.mobileNumber === '1') {
          this.commonServices.showMessage('error', 'Non US mobile numbers are not allowed for mobile OTP.', 5);
        }
      }
    }, error => {
      this.commonServices.showMessage('error', error, 3);
    })
  }

  generateOtpUserRequest() {
    if (this.otpTypeEmailMobile.value === 'mobile') {
      this.GenerateMobileOtp(this.loginForm.controls.EmailId.value.trim(), 'For Password Reset - Mobile OTP');
    }
    if (this.otpTypeEmailMobile.value === 'email') {
      this.GenerateEmailOtp(this.loginForm.controls.EmailId.value.trim(), 'For Password Reset - Email OTP');
    }
  }

  onVerifyOtpRequest(verification: string) {
    if (!this.VerificationEmailOtp.valid) {
      this.commonServices.showMessage('error', 'Please provide valid OTP', 5);
      return;
    }
    if (verification === 'email') {
      this.VerifyOtp(this.emailOtpRequestId, this.VerificationEmailOtp.value.trim(), this.loginForm.controls.EmailId.value.trim());
    }
    if (verification === 'mobile') {
      this.VerifyOtp(this.mobileOtpRequestId, this.VerificationOtpMobile.value.trim(), this.loginForm.controls.EmailId.value.trim());
    }
  }

  onFinalResetPassword() {
    if (!this.NewPassword.valid) {
      this.commonServices.showMessage('error', 'Please provide valid password', 5);
      return;
    }
    this.ResetPassword(this.loginForm.controls.EmailId.value.trim(), this.NewPassword.value.trim());
  }

  LogonBackToLoginin() {
    this.emailOtpRequestId = 0;
    this.isEmailVerified = false;
    this.isForgotPasswordPcessStarted = false;
    this.userComDetails = undefined;
  }

  removeSpaces() {
    const value = this.NewPassword.value || '';
    this.NewPassword.setValue(value.replace(/\s+/g, ''), { emitEvent: false });
  }

  onOtpTypeChange(event: any) {
    this.emailOtpRequestId = 0;
    this.mobileOtpRequestId = 0;
    this.isEmailVerified = false;
    this.isMobileVerified = false;
    this.VerificationEmailOtp.reset();
    this.VerificationOtpMobile.reset();
    this.stopOtpTimer();
    this.otp_timer = 0;
  }
}
